export default __webpack_public_path__ + "static/lea-verou-1e0416f4de94a11a3e7d9c5d49d2b363.jpg";